"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHVACErrorMessageI18nKey = exports.getHVACErrorMessageKey = void 0;
const getHVACErrorMessageKey = (errorStatus) => {
    if (!errorStatus.hasError) {
        return null;
    }
    switch (errorStatus.errorType) {
        case 'airHandler':
            return 'common.airHandlerOffline';
        case 'condenser':
            return 'common.condenserOffline';
        case 'multipleSensors':
            return 'common.multipleSensorsOffline';
        default:
            return null;
    }
};
exports.getHVACErrorMessageKey = getHVACErrorMessageKey;
const getHVACErrorMessageI18nKey = (errorStatus) => {
    if (!errorStatus.hasError) {
        return null;
    }
    switch (errorStatus.errorType) {
        case 'airHandler':
            return 'hvac.airHandlerOffline';
        case 'condenser':
            return 'hvac.condenserOffline';
        case 'multipleSensors':
            return 'hvac.multipleSensorsOffline';
        default:
            return null;
    }
};
exports.getHVACErrorMessageI18nKey = getHVACErrorMessageI18nKey;
